import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }

import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import Otp from '@/components/forms/Otp.vue';

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import PageLoader from "@/components/loaders/PageLoader.vue"
import SuccessModal from '@/components/modals/SuccessModal.vue';

import ForgotPassword from '@/classes/ForgotPassword';

import { errorResponse } from "@/helpers/errorMessage";

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationCode',
  setup(__props) {

const router = useRouter();
const route = useRoute();


const loading = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showResentSuccess = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();

const email = ref<string>('');

const form = ref<{
    email: string
    code: string | null
    token: string | null
}>({
    email: route.query.email,
    code: null,
    token: null
})

const submit = (otp:string):void =>{
    loading.value = true;

    form.value.code = otp;
    
    ForgotPassword.verifyOtp(form.value)
        .then(({ data }) => {
            console.log(data);
            loading.value = false;
            showSuccess.value = true;
            successMessage.value = 'OTP has been verified!';
            form.value.token = data.success.token;
        }).catch((error) => {
            loading.value = false;
            errors.value = errorResponse(error.response?.data?.errors)
        });
}
const resendOtp = ():void =>{
    loading.value = true;
    ForgotPassword.instantiate(form.value)
        .then(({ data }) => {
            loading.value = false;
            showResentSuccess.value = true;

            successMessage.value = 'New OTP has been set to your email!';
        }).catch((error) => {
            loading.value = false;

            errors.value = errorResponse(error.response?.data?.errors)
        });
}

const confirm = (): void => {
    router.replace({ path: '/reset-password', query: form.value })
}

onMounted(() => {
    if (typeof route.query.email == 'undefined' )
    { 
        router.replace({ path: '/login' })
    }

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "Enter your account 6-digit OTP",
                  description: "Please enter the numeric SIX digit code sent to your email"
                }),
                (errors.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(Object.values(errors.value)[0]), 3))
                  : _createCommentVNode("", true),
                _createVNode(Otp, {
                  bottonName: "Submit",
                  "onUpdate:submit": _cache[0] || (_cache[0] = (value) => submit(value)),
                  "onUpdate:resendOtp": resendOtp,
                  hasSubmit: "",
                  showResend: ""
                })
              ])
            ])
          ]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: confirm,
            "action-text": "Close",
            title: "Success!",
            content: successMessage.value
          }, null, 8, ["show", "content"]),
          _createVNode(SuccessModal, {
            show: showResentSuccess.value,
            onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showResentSuccess.value = false)),
            "action-text": "Close",
            title: "Success!",
            content: successMessage.value
          }, null, 8, ["show", "content"]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})